import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "#193446",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M13.995 15.56c0-1.37 1.12-2.49 2.49-2.49s2.49 1.12 2.49 2.49-1.12 2.49-2.49 2.49-2.49-1.12-2.49-2.49Zm3.49 0c0-.55-.45-.99-.99-.99s-.99.45-.99.99.45.99.99.99.99-.45.99-.99Z" fill="currentColor" /> <path d="M2.895 13.5v-2.98c0-4.7 3.82-8.52 8.52-8.52h2.98c4.7 0 8.52 3.82 8.52 8.52v2.98c0 4.7-3.82 8.52-8.52 8.52h-2.98c-4.7 0-8.52-3.82-8.52-8.52Zm18.52-2.98c0-3.87-3.15-7.02-7.02-7.02h-2.98c-3.87 0-7.02 3.15-7.02 7.02v2.98c0 3.87 3.15 7.02 7.02 7.02h2.98c3.87 0 7.02-3.15 7.02-7.02v-2.98Z" fill="currentColor" />' }
  })
);